const BILLING_PLAN_INTENT_KEY = 'ci-billing-plan-intent';

const normalizePlanId = (planId?: string | null): string | null => {
  const trimmed = planId?.trim();
  return trimmed || null;
};

export const setPendingBillingPlanId = (planId?: string | null): string | null => {
  const normalized = normalizePlanId(planId);
  if (typeof window === 'undefined') {
    return normalized;
  }

  try {
    if (normalized) {
      localStorage.setItem(BILLING_PLAN_INTENT_KEY, normalized);
    } else {
      localStorage.removeItem(BILLING_PLAN_INTENT_KEY);
    }
  } catch {
    /* Local storage can be unavailable in private browsing or SSR. */
  }

  return normalized;
};

export const getPendingBillingPlanId = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return normalizePlanId(localStorage.getItem(BILLING_PLAN_INTENT_KEY));
  } catch {
    return null;
  }
};

export const clearPendingBillingPlanId = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(BILLING_PLAN_INTENT_KEY);
  } catch {
    /* Ignore storage failures. */
  }
};

export const billingPathForPlanIntent = (planId?: string | null): string => {
  const normalized = normalizePlanId(planId);
  return normalized ? `/billing?plan=${encodeURIComponent(normalized)}` : '/billing';
};
